/**
 * Individual statistics card component with title, value, and optional icon.
 * Supports multiple colors, loading states, and custom styling.
 * Used for displaying key metrics and statistics throughout the app.
 * Used in Dashboard, UsersPage, MedicalCentersPage, and CallSessionsPage.
 */


import React from 'react';

const StatCard = ({ 
  title, 
  value, 
  subtitle, 
  icon, 
  color = 'blue',
  loading = false,
  className = '' 
}) => {
  const colors = {
    blue: 'text-blue-600',
    green: 'text-green-600',
    purple: 'text-purple-600',
    orange: 'text-orange-600',
    red: 'text-red-600',
    indigo: 'text-indigo-600'
  };

  if (loading) {
    return (
      <div className={`card ${className}`}>
        <div className="animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
          <div className="h-8 bg-gray-200 rounded w-1/2 mb-2"></div>
          <div className="h-3 bg-gray-200 rounded w-1/3"></div>
        </div>
      </div>
    );
  }

  return (
    <div className={`card ${className}`}>
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
          <p className={`text-3xl font-bold ${colors[color]}`}>{value}</p>
          {subtitle && (
            <p className="text-sm text-gray-500 mt-1">{subtitle}</p>
          )}
        </div>
        {icon && (
          <div className={`p-3 rounded-full bg-gray-100 ${colors[color]}`}>
            {icon}
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;